import React from "react"
import * as AppConstants from "../../utility/AppConstants"
import 'Css/table.css'
import * as Utility from "../../utility/Utility"

function HeaderTable(props: any) {
    return (
        <React.Fragment>
            <tr>
                <th style={{width:'20rem'}}>
                    {Utility.getValoreHeader(props.codIsa, props.macroarea)}{" "}
                </th>
                {props.isCampo1 ? (
                    <th className="th-statistiche">
                        {AppConstants.TITLE_RE.toUpperCase()}{" "}
                    </th>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <th className="th-statistiche">
                        {AppConstants.TITLE_RG.toUpperCase()}{" "}
                    </th>
                ) : (
                    <React.Fragment />
                )}
                <th className="th-statistiche">
                    {AppConstants.TITLE_RF.toUpperCase()}
                </th>
                <th className="th-statistiche">
                    {AppConstants.TITLE_TOTALE.toUpperCase()}
                </th>
            </tr>
        </React.Fragment>
    )
}
export default HeaderTable
